import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "form-element-ok",
  "use": "form-element-ok-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"form-element-ok\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#ECECEC\" cx=\"18\" cy=\"18\" r=\"18\" /><path d=\"M6 6h24v24H6z\" /><path d=\"M15.593 22.458a1.365 1.365 0 01-.207-.17l-3.842-3.842a1.358 1.358 0 011.921-1.921l3.042 3.042 6.102-6.102a1.358 1.358 0 011.921 1.921l-7.044 7.045c-.522.52-1.36.53-1.893.027z\" fill=\"#003595\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol